export default async function getRecaptchaToken() {
  await window.grecaptcha.ready;
  const token = await window.grecaptcha.execute(
    "6LcPu6QUAAAAAFhcokv4hUUb3JzbahmnD1GmpjGN",
    { action: "main_form" }
  );
  return token;
}
